import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Layout
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import Scroll from "./scroll/scroll";


import PPCLayout from "./PPC/PPCLayout";
import PPC1 from "../Pages/PPC/PPC1";
import LP_PPC1 from "../lp/PPC1";
import LPLayout from "../lp/LPLayout";
import PPC2Layout from "../lp/ppc2/layout";
import PPC2Page from "../lp/ppc2/page";
import PPC3Layout from "../lp/ppc3/layout";
import PPC3Page from "../lp/ppc3/page";

// ⭐ ADD THIS

// Pages
import Homepage from "./homepage";
import ThankYou from "./thankyou";

// Services
import CrownAndBridges from "../Pages/Services/dental-crowns-and-bridges-in-hsr";
import DentalImplants from "../Pages/Services/dental-implants-in-hsr";
import Braces from "../Pages/Services/braces-in-hsr";
import TeethWhitening from "../Pages/Services/teeth-whitening-in-hsr";
import RootCanalTreatment from "../Pages/Services/root-canal-treatment-in-hsr";
import DentalExtraction from "../Pages/Services/dental-extraction-in-hsr";
import ChildrenDentistry from "../Pages/Services/children-dentistry-in-hsr";
import TraumaCare from "../Pages/Services/trauma-care-in-hsr";
import ToothRestoration from "../Pages/Services/tooth-restoration-in-hsr";
import DentalCrown from "../Pages/Services/dental-crown-in-hsr";
import PreventiveDentistry from "../Pages/Services/preventive-dentistry-in-hsr";
import ClearAligners from "../Pages/Services/clear-aligners-in-hsr";
import ReRootCanal from "../Pages/Services/re-root-canal-in-hsr";
import FMR from "../Pages/Services/fmr-in-hsr";
import Dentures from "../Pages/Services/dentures-in-hsr";
import Aligners from "../Pages/Services/aligners-in-hsr";


import BlogPage from "./Blog/BlogPage";
import AllBlogs from "./Blog/AllBlogs";


const Layout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    }
  }, [location]);

  // ⭐ EXCLUDE ONLY Thank You Page
  const isThankYouPage = location.pathname === "/thankyou";

  return !isThankYouPage ? (
    <>
      <Navbar />
      <Scroll /> {/* ⭐ FLOATING BUTTONS AVAILABLE ON ALL PAGES */}
      {children}
      <Footer />
    </>
  ) : (
    children
  );
};

const Home = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Homepage />
          </Layout>
        }
      />

      <Route path="/thankyou" element={<ThankYou />} />

      {/* Service Pages */}
      <Route
        path="/services/dental-crowns-and-bridges-in-hsr"
        element={
          <Layout>
            <CrownAndBridges />
          </Layout>
        }
      />
      <Route
        path="/services/dental-implants-in-hsr"
        element={
          <Layout>
            <DentalImplants />
          </Layout>
        }
      />
      <Route
        path="/services/braces-in-hsr"
        element={
          <Layout>
            <Braces />
          </Layout>
        }
      />
      <Route
        path="/services/aligners-in-hsr"
        element={
          <Layout>
            <Aligners />
          </Layout>
        }
      />
      <Route
        path="/services/teeth-whitening-in-hsr"
        element={
          <Layout>
            <TeethWhitening />
          </Layout>
        }
      />
      <Route
        path="/services/root-canal-treatment-in-hsr-layout"
        element={
          <Layout>
            <RootCanalTreatment />
          </Layout>
        }
      />
      <Route
        path="/services/dental-extraction-in-hsr-layout"
        element={
          <Layout>
            <DentalExtraction />
          </Layout>
        }
      />
      <Route
        path="/services/children-dentistry-in-hsr-layout"
        element={
          <Layout>
            <ChildrenDentistry />
          </Layout>
        }
      />
      <Route
        path="/services/TraumaCare-in-hsr-layout"
        element={
          <Layout>
            <TraumaCare />
          </Layout>
        }
      />
      <Route
        path="/services/tooth-restoration-in-hsr-layout"
        element={
          <Layout>
            <ToothRestoration />
          </Layout>
        }
      />
      <Route
        path="/services/dental-crown-in-hsr-layout"
        element={
          <Layout>
            <DentalCrown />
          </Layout>
        }
      />
      <Route
        path="/services/preventive-dentistry-in-hsr-layout"
        element={
          <Layout>
            <PreventiveDentistry />
          </Layout>
        }
      />
      <Route
        path="/services/clear-aligners-in-hsr-layout"
        element={
          <Layout>
            <ClearAligners />
          </Layout>
        }
      />
      <Route
        path="/services/re-root-canal-in-hsr-layout"
        element={
          <Layout>
            <ReRootCanal />
          </Layout>
        }
      />
      <Route
        path="/services/fmr-in-hsr-layout"
        element={
          <Layout>
            <FMR />
          </Layout>
        }
      />
      <Route
        path="/services/dentures-in-hsr-layout"
        element={
          <Layout>
            <Dentures />
          </Layout>
        }
      />



      {/* Blog Page */}
      <Route
        path="/blog/:slug"
        element={
          <Layout>
            <BlogPage />
          </Layout>
        }
      />

      <Route
        path="/blogs"
        element={
          <Layout>
            <AllBlogs />
          </Layout>
        }
      />

      <Route
        path="/ppc1"
        element={
          <PPCLayout>
            <PPC1 />
          </PPCLayout>
        }
      />

      <Route
        path="/lp/PPC1"
        element={
          <LPLayout>
            <LP_PPC1 />
          </LPLayout>
        }
      />

      <Route
        path="/lp/ppc2"
        element={
          <PPC2Layout>
            <PPC2Page />
          </PPC2Layout>
        }
      />

      <Route
        path="/lp/ppc3"
        element={
          <PPC3Layout>
            <PPC3Page />
          </PPC3Layout>
        }
      />

    </Routes>


  );
};

export default Home;
